export default __webpack_public_path__ + "static/media/428.bd6a3e2e.jpg";